module.exports = __webpack_public_path__ + "b12bf761690d6aa654160939b3f4305f.svg";